import type {
  FieldValue,
  FilterValues,
} from '@src/components/FilterDropDown/FilterDropDown.interfaces';

/**
 * Maps widget `FilterValues` to the flat `columnFilters` object expected by `buildTableParams` / TABLE_DASHBOARD.
 * Skips empty values (aligned with FilterActiveTags visibility).
 */
export const widgetFilterValuesToColumnFilters = (
  widgetFilterValues: FilterValues | null | undefined,
): Record<string, FieldValue> => {
  if (!widgetFilterValues || typeof widgetFilterValues !== 'object') {
    return {};
  }
  return Object.entries(widgetFilterValues).reduce<Record<string, FieldValue>>((acc, [key, entry]) => {
    const v = entry?.value;
    if (v === undefined || v === null || v === '') return acc;
    if (Array.isArray(v) && v.length === 0) return acc;
    acc[key] = v;
    return acc;
  }, {});
};
